import { z } from 'zod';

export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 10;

export const emailSchema = z.string().email();

export const formSchema = z.object({
  searchDates: z
    .object({
      from: z.date(),
      to: z.union([z.date(), z.undefined()]),
    })
    .optional(),
  searchValue: z
    .string()
    .min(1, 'Okta ID / Email cannot be empty')
    .transform((value) => value.trim()),
});

export type FormValues = z.infer<typeof formSchema>;

export const querySchema = z.object({
  email: z.string().default(''),
  from: z.string().optional().catch(undefined),
  id: z.string().default(''),
  page: z.number().default(DEFAULT_PAGE_INDEX),
  sessionId: z.string().optional().catch(undefined),
  size: z.number().default(DEFAULT_PAGE_SIZE),
  to: z.string().optional().catch(undefined),
});

export type QueryParams = z.infer<typeof querySchema>;
